import { createContext, useContext, useState, useEffect } from "react";

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
    const [isExpanded, setIsExpanded] = useState(() => {
        const saved = localStorage.getItem("sidebarExpanded");
        return saved === null ? true : JSON.parse(saved);
    });

    useEffect(() => {
        localStorage.setItem("sidebarExpanded", JSON.stringify(isExpanded));
    }, [isExpanded]);

    return (
        <SidebarContext.Provider value={{ isExpanded, setIsExpanded }}>
            {children}
        </SidebarContext.Provider>
    );
};

export const useSidebar = () => useContext(SidebarContext);